import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "relative" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "absolute bottom-0 right-0 w-3 h-3 bg-red-500 rounded-full"
};
import { computed } from 'vue';
import toMaterialStyle from 'material-color-hash';
import constants from '@/constants';
import UserBadge from '@/components/users/UserBadge.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Avatar',
    props: {
        disconnected: { type: Boolean, default: false },
        errorBorder: { type: Boolean, default: false },
        showBadges: { type: Boolean, default: false },
        showTooltip: { type: Boolean, default: true },
        size: { type: String, default: 'md' },
        user: { type: Object, default: null }
    },
    setup(__props) {
        const props = __props;
        const badgeType = computed(() => {
            const { user } = props;
            if ('motivation' in user) {
                return constants.MOTIVATION_FACES[user.motivation] || null;
            }
            return null;
        });
        const initial = computed(() => {
            return props.user.name?.charAt(0).toUpperCase();
        });
        const materialColor = computed(() => {
            const shade = 500;
            return toMaterialStyle(props.user.name || '', shade).backgroundColor;
        });
        const connectedStyle = computed(() => {
            return props.user.avatar ? null : { background: materialColor.value };
        });
        const errorClasses = computed(() => {
            return props.errorBorder ? 'border-2 border-red-500 dark:border-red-500' : null;
        });
        const styles = computed(() => {
            return props.user ? connectedStyle.value : null;
        });
        const userClasses = computed(() => {
            return props.user
                ? 'bg-cover print:border-primary-400 text-white'
                : 'bg-gray-100 dark:bg-gray-700 border-gray-300 text-gray-300 dark:text-gray-400';
        });
        const sizeClasses = computed(() => {
            switch (props.size) {
                case 'sm':
                    return 'w-6 h-6';
                // TODO: Consider re making the Avatar component to use full width instead
                // and to not depend on a user object.
                case 'md-but-a-bit-smaller':
                    return 'w-8 h-8';
                case 'md':
                    return 'w-10 h-10';
                case 'lg':
                    return 'w-24 h-24';
                case 'xl':
                    return 'w-32 h-32';
                default:
                    return 'w-10 h-10';
            }
        });
        const textSize = computed(() => {
            switch (props.size) {
                case 'sm':
                    return 'text-xs';
                case 'md':
                    return 'text-lg';
                case 'md-but-a-bit-smaller':
                    return 'text-lg';
                case 'lg':
                    return 'text-4xl';
                case 'xl':
                    return 'text-5xl';
                default:
                    return 'text-lg';
            }
        });
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([`${_unref(sizeClasses)} ${_unref(userClasses)} ${_unref(errorClasses)}`, "flex items-center justify-center overflow-hidden rounded-full"]),
                    style: _normalizeStyle(_unref(styles))
                }, [
                    (__props.user && __props.user.avatar)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: __props.user.avatar,
                            class: "object-cover w-full h-full rounded-full"
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true),
                    (__props.user && !__props.user.avatar)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(_unref(textSize))
                        }, _toDisplayString(_unref(initial)), 3))
                        : (!__props.user)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                class: _normalizeClass(_unref(textSize))
                            }, "?", 2))
                            : _createCommentVNode("", true)
                ], 6)), [
                    [_directive_tooltip, __props.showTooltip ? __props.user?.name : null]
                ]),
                (__props.disconnected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                    : (__props.showBadges)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (__props.user && _unref(badgeType))
                                ? (_openBlock(), _createBlock(UserBadge, {
                                    key: 0,
                                    type: _unref(badgeType),
                                    class: "absolute bottom-0 right-0 w-3 h-3"
                                }, null, 8, ["type"]))
                                : _createCommentVNode("", true)
                        ], 64))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
